import { useCallback, useEffect, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type Invoice } from '../../domain/Invoice'
import { getShipmentInvoices } from '../../use-cases/getShipmentInvoices'

export function useGetInvoices(shipmentUUID: string) {
  const [invoices, setInvoices] = useState<Invoice[]>([])
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const fetchInvoices = useCallback(async (uuid: string, abortController?: AbortController) => {
    setRequestStatus(RequestStatus.Pending)

    try {
      const result = await getShipmentInvoices(uuid, abortController)
      setInvoices(result)
      setRequestStatus(RequestStatus.Done)
    } catch (error) {
      if (!abortController?.signal.aborted) {
        sentry.log(error)
        setRequestStatus(RequestStatus.Error)
      }
    }
  }, [])

  useEffect(() => {
    const abortController = new AbortController()

    fetchInvoices(shipmentUUID)

    return () => {
      abortController.abort()
    }
  }, [fetchInvoices, shipmentUUID])

  return { invoices, fetchInvoices, requestStatus }
}
